import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from 'react-hook-form';
import { Card, Button } from '@mui/material';
import { useParams, useHistory } from 'react-router';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import { ViewTitle } from '../../components/ViewTitle';
import { BackButton } from '../../components/Button';
import { MaintenanceTopicsForm } from '../../components/Forms';
import { Loading } from '../../components/Loading';
import { Error } from '../../components/Error';

export default function EditMaintenanceTopics({ title, subtitle }) {
  const dispatch = useDispatch();
  const { id } = useParams();
  const history = useHistory();
  const maintenanceTopics = useSelector((state) => state.maintenanceTopics);
  const maintenanceTypes = useSelector((state) => state.maintenanceTypes);
  const {
    formState: { errors },
    handleSubmit,
    control,
  } = useForm({
    defaultValues: {
      name: maintenanceTopics.name,
      type: maintenanceTopics.type,
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(actions.maintenanceTopicGet(id));
      await dispatch(actions.maintenanceTypeAll({}));
    };

    fetchData();

    return () => {};
  }, []);

  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;

  const onSubmit = async (data) => {
    try {
      console.log('data', data);
      await dispatch(actions.maintenanceTopicPut(id, data));
      alert('สำเร็จ');
      history.goBack();
    } catch (error) {
      console.log(error);
    }
  };
  if (
    maintenanceTypes.isLoading ||
    maintenanceTopics.isLoading ||
    maintenanceTopics.rows
  ) {
    return <Loading />;
  }
  if (
    !maintenanceTypes.isLoading &&
    maintenanceTypes.isCompleted &&
    !maintenanceTopics.isLoading &&
    maintenanceTopics.isCompleted
  ) {
    return (
      <div>
        {renderTitle()}
        <div className="flex flex-row justify-start pb-4">
          <div>
            <BackButton />
          </div>
        </div>
        <div>
          <Card className="p-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <MaintenanceTopicsForm
                errors={errors}
                maintenanceTopics={maintenanceTopics}
                maintenanceTypes={maintenanceTypes}
                control={control}
                Controller={Controller}
              />
              <div className="flex flex-row justify-end gap-1 py-4">
                <Button variant="contained" type="submit">
                  บันทึก
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </div>
    );
  }
  return <Error />;
}
EditMaintenanceTopics.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

EditMaintenanceTopics.defaultProps = {
  title: '',
  subtitle: '',
};
